import { createContext, useContext, ReactNode, FC } from 'react';
import { RuntimeConfig } from '@/types/RuntimeConfig';
import { getConfig } from '@/utils/runtimeConfig';

interface ConfigContextType {
  config: RuntimeConfig;
}

const config = getConfig();

const ConfigContext = createContext<ConfigContextType>({
  config,
});

export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};

interface ConfigProviderProps {
  children: ReactNode;
}

export const ConfigProvider: FC<ConfigProviderProps> = ({ children }) => {
  return (
    <ConfigContext.Provider value={{ config }}>
      {children}
    </ConfigContext.Provider>
  );
};

